import Anchor from "../../helpers/anchor";
import { guid } from "../../helpers/generators";

export default function Element({ name, props, ...other }) {
    const id = guid();
    return {
        name: name ?? "Block",
        props: { id, ...props, id },
        ...other,
    };
}

export function toElementProps(originProps = {}, addProps = {}, addData = {}) {
    const { even, odd } = originProps;
    const evenOdd = [];
    (even || odd) && evenOdd.push(even ? "even" : "odd");

    const block = {};
    if (originProps._block) {
        const anchor =
            typeof originProps._block === "string" ? originProps._block : originProps._block[addData.language ?? "en"];
        block.id = Anchor(anchor);
    }

    const intersect = [];
    if (originProps.intersect && !originProps.ignoreIntersect) {
        intersect.push("-intersect-");
    }

    const className = [...(originProps.className || []), ...(addProps.className || []), ...evenOdd, ...intersect];
    const style = { ...(originProps.style || {}), ...(addProps.style || {}) };
    const attrs = { ...(originProps.attrs || {}), ...(addProps.attrs || {}), ...block };
    return { className: className.join(" "), style, ...attrs };
}
